export default {
    // 忘记密码
    // /organizationstructure/verificationImage/init
    verificationImageInit: `/api/organizationstructure/verificationImage/init`, //获取图形验证码
    verificationImagCheck: `/api/organizationstructure/verificationImage/check`, //检测图片是否正确
    pwdCode: `/api/organizationstructure/pwd/code`, //忘记密码获取手机验证码
    pwdReset: `/api/organizationstructure/pwd/reset`, //重置密码
    
    switchboardIdentityChange: `/api/organizationstructure/switchboardIdentity/change`, //切换编号首页
    switchboardAssignment: `/api/organizationstructure/switchboardIdentity/assignment`,//用户获取所有的编号
    switchboardAccepte: `/api/organizationstructure/switchboardIdentity/accepte`, //同意编号
    switchboardRefuse: `/api/organizationstructure/switchboardIdentity/refuse`, //拒绝编号

    companyList: `/api/organizationstructure/department/list`, //
    showCompany: `/api/organizationstructure/switchboard/show`, //我的公司详情\
    updateCompany: `/api/organizationstructure/switchboard/update`,
  
    listMenu: `/api/organizationstructure/roleMenu/listMenu`, //当前登录者拥有的菜单权限集合

    addRole: `/api/organizationstructure/role/add`, //添加角色
    updateRole: `/api/organizationstructure/role/update`, //修改角色
    deleteRole: `/api/organizationstructure/role/delete`, //删除角色
    roleList: `/api/organizationstructure/role/listWithCount`, //角色列表

    companyDetails: `/api/organizationstructure/switchboard/show`, //公司详情 
    updateCompany: `/api/organizationstructure/switchboard/update`, //修改公司信息
    shownumber: `/api/organizationstructure/switchboardIdentity/show`, //编号详情
    addNumber: `/api/organizationstructure/switchboardIdentity/add`, //添加编号
    // 000新增
    isVerifyPwd: `/api/organizationstructure/switchboardIdentity/verifyPwd`,//根据手机号码查询是否设置过密码
    numberList: `/api/organizationstructure/switchboardIdentity/list`, //编号列表
    updateNumber: `/api/organizationstructure/switchboardIdentity/update`, //修改编号
    showParentList: `/api/organizationstructure/department/departmentListTree`, //添加编号 选择部门列表
    showRoleList: `/api/organizationstructure/role/listNoPage`, //添加编号 选择角色列表
    outNumber: `/api/organizationstructure/switchboardIdentity/changStatusOutOfUse`, //停用编号
    batchNumber: `/api/organizationstructure/switchboardIdentity/batchChangeRoles`, //批量修改编号
    departmentName: `/api/organizationstructure/department/show`,//部门名称
    identityPageCount: `/api/organizationstructure/switchboardIdentity/count`, //编号列表分页总数

    addDepartment: `/api/organizationstructure/department/add`, //添加部门
    deletePartment: `/api/organizationstructure/department/delete`, //删除部门
    updatePartment: `/api/organizationstructure/department/update`, //修改部门
    addChildPartment: `/api/organizationstructure/department/addson`, //添加子级部门

    companyAdd: `/api/organizationstructure/switchboard/add`, //新增公司
    companyUpdate: `/api/organizationstructure/department/update`, //

    roleMenuList: `/api/organizationstructure/roleMenu/list`, //
    businessSystemList: `/api/organizationstructure/businessSystem/list`, //
    roleMenuDynamicNode: `/api/organizationstructure/roleMenu/listDynamicNode`,
    roleMenuListByName: `/api/organizationstructure/roleMenu/listByName`, //权限设置相同权限参考
    roleMenuDynamicNodeByName: `/api/organizationstructure/roleMenu/listDynamicNodeByName`,//权限设置不同权限参考
    roleMenuCustomize: `/api/organizationstructure/roleMenu/customize`, //权限-自定义-入口
    roleMenuCustomizeSon: `/api/organizationstructure/roleMenu/customizeSon`, //权限-自定义-递归节点


    systemList: `/api/organizationstructure/businessSystem/list`, //系统列表
    systemListWithMongo: `/api/organizationstructure/businessSystem/listWithMongo`, //系统列表含mongo
    systemAdd: `/api/organizationstructure/businessSystem/add`, //添加系统
    systemDelete: `/api/organizationstructure/businessSystem/delete`, //删除系统
    systemUpdate: `/api/organizationstructure/businessSystem/update`, //编辑系统
    systemShow: `/api/organizationstructure/businessSystem/show`, //系统详情
    tapSystem: `/api/organizationstructure/businessSystem/change`, //切换系统
    getDataSourceStat: `/api/organizationstructure/dataSource/getDataSourceStat`, //mongo列表

    menuList: `/api/admin/organizationstructure/menu/list`,//菜单列表
    menuUpdate: `/api/admin/organizationstructure/menu/update`,//修改菜单
    menuAdd: `/api/admin/organizationstructure/menu/add`,//添加顶级菜单   新建子级菜单
    menuDelete: `/api/admin/organizationstructure/menu/delete`,//删除菜单
    menuShow: `/api/admin/organizationstructure/menu/show`,

    downloadTemplateExcel: `/api/organizationstructure/switchboardIdentity/downloadTemplateExcel`,//下载批量编号模板
    importExcel: `/api/organizationstructure/switchboardIdentity/importExcel`,//批量导入编号
    excelList: `/api/organizationstructure/switchboardIdentity/excelList`,//导出编号


    roleMenuUpdateFixedMenu: `/api/organizationstructure/roleMenu/updateFixedMenu`, //修改权限：我的公司
    roleMenuUpdateBusinessSystemMenu: `/api/organizationstructure/roleMenu/updateBusinessSystemMenu`, //修改权限：定制+表单+报表
    roleMenuGetImportLog: `/api/organizationstructure/roleMenu/getImportLog`, //修改权限：角色导入历史查询接口
    

    updateKey: `/api/organizationstructure/businessSystem/updateKey`,//更新公钥和密钥
    webLogList: `/api/organizationstructure/weblog/list`,//日志列表
    calcSignList: `/api/admin/organizationstructure/calcSign/list`,//指数列表
    calcSignShow: `/api/admin/organizationstructure/calcSign/show`,//指数详情
    calcSignUpdate: `/api/admin/organizationstructure/calcSign/update`,//修改指数
    historyList: `/api/organizationstructure/switchboardIdentityHistory/list`, //编号导入历史
    getServerResourceInfo: `/api/organizationstructure/serverResourceMonitor/getServerResourceInfo`, //服务器资源信息
    getCacheInfo: `/api/organizationstructure/serverResourceMonitor/getCacheInfo`, //redis信息
    getCacheObjList: `/api/organizationstructure/serverResourceMonitor/getCacheObjList`, //redis中缓存的对象信息

    // 分库
    listFkInfo: `/api/organizationstructure/businessSystem/listFkInfo`, //查询系统-域名-表单
    dataSourceList: `/api/organizationstructure/dataSource/list`, //查询数据源列表
    dataSourceAdd: `/api/organizationstructure/dataSource/add`, //增加数据源
    dataSourceUpdate: `/api/organizationstructure/dataSource/update`, //修改数据源
    dataSourceDelete: `/api/organizationstructure/dataSource/delete`, //删除数据源
    tableRuleList: `/api/organizationstructure/tableRule/list`, //查询分库列表
    listTableRuleDatasource: `/api/organizationstructure/tableRule/listTableRuleDatasource`, //查询分库详情
    tableRuleDetail: `/api/organizationstructure/tableRule/listTableRuleTime`,
    tableRuleAdd: `/api/organizationstructure/tableRule/add`, //新增数据库拆分规则（第一次拆分调新增)
    tableRuleTimeAdd: `/api/organizationstructure/tableRuleTime/add`, //新增数据库拆分规则（第一次拆分调新增)
    tableRuleDetailUpdate: `/api/organizationstructure/tableRule/update`, //修该拆分规则
    tableRuleDetailDelete: `/api/organizationstructure/tableRule/delete`, //删除数据库拆分

}